<template>
  <div class="new_box">
    <sellheader></sellheader>
    <div class="content">
      <div
        :style="{ backgroundImage: 'url(' + backgroundImg + ')' }"
        style="background-size: cover; min-height: 300px; position: relative"
        class="inner-banner"
      >
        <section class="w3l-breadcrumb">
          <div class="container">
            <ul class="breadcrumbs-custom-path">
              <li><a href="./">首页</a></li>
              <li class="active">
                <span
                  class="fa fa-chevron-right mx-2"
                  aria-hidden="true"
                ></span>
                新闻中心
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="news_list">
        <div class="new_type">
          <ul>
            <li @click="option(1)" :class="type == 1 ? 'type' : ''">
              公司新闻
            </li>
            <li @click="option(2)" :class="type == 2 ? 'type' : ''">
              行业新闻
            </li>
            <li @click="option(3)" :class="type == 3 ? 'type' : ''">
              政策法规
            </li>
          </ul>
        </div>
        <section class="w3l-blogpost-content w3l-courses py-5">
          <div class="container py-md-5">
            <div class="row">
              <div
                v-for="(item, index) in newsList"
                :key="index"
                style="cursor: pointer; padding-left: 200px;"
              >
                <router-link :to="'/newsInfo' + '?newsid=' + item.id">
                  <div class="titles" @click="jump(item.id)">
                    <span>{{ item.newsTitle }} </span>
                  </div>
                  <div class="times">
                    <div style="color:#651984">
                      {{ parseTime(item.createTime, "{y}-{m}-{d}") }}
                    </div>
                  </div>

                  <!-- <div class="card">
                    <div class="card-header p-0 position-relative">
                      <span>
                        <img
                          class="card-img-bottom d-block radius-image-full"
                          :src="item.picUrl"
                          alt="Card image cap"
                        />
                      </span>
                    </div>
                    <div class="card-body blog-details">
                      <p class="price-review">{{ item.newsTitle }}</p>
                      <span style="font-size: 14px" class="blog-desc mt-2">{{
                        item.sketch
                      }}</span>
                      <div class="course-meta mt-1">
                        <div class="meta-item course-students">
                          <span style="font-size: 12px" class="meta-value">
                            {{ item.createTime }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </router-link>
              </div>
            </div>
            <div class="course-button mt-lg-2 text-center">
              <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getNewsList"
    />
            </div>
          </div>
        </section>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import sellheader from "@/views/home/header/index.vue";
import footers from "@/views/footer/index.vue";
import { newslist } from "@/api/news/index";
import { bannerList } from "@/api/menu/index.js";
export default {
  components: {
    sellheader,
    footers,
  },
  data() {
    return {
      backgroundImg: "",
      type: 1,
      newsList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        newsType: 1,
        status:0,
        orderByColumn:'sort',
        isAsc:'desc'
      },
      total: 0,
      imgqueryParams: {
        picType: "news",
      },
    };
  },
  watch: {
    $route(to, from) {
      let selectId = to.query.selectid;
      this.queryParams.newsType = selectId;
      this.type = selectId;
      this.getNewsList();
    },
  },
  mounted() {
    let selectid = this.getUrlKey("selectid");
    if (selectid != null) {
      this.type = selectid;
      this.queryParams.newsType = selectid;
    }

    this.getNewsList();
    this.getBannerList();
    this.option(this.type)
  },
  methods: {
    getBannerList() {
      bannerList(this.imgqueryParams).then((res) => {
        if (res.total > 0) {
          this.backgroundImg = res.rows[0].picUrl;
        }
      });
    },
    option(type) {
      this.type = type;
      this.queryParams.newsType = type;

      this.getNewsList();
    },
    getNewsList() {
      newslist(this.queryParams).then((res) => {
        this.total = res.total;
        this.newsList = res.rows;
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 992px) {
  .new_type {
    width: 25%;
  }
}
@media (max-width: 992px) {
  .new_type {
    width: 80%;
  }
}

.new_type {
  height: 80px;
  line-height: 80px;
  margin: auto;
  ul {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  ul li {
    float: left;
    width: 100px;
    height: 80px;
    text-align: center;
    margin: auto;
    cursor: pointer;
    display: block;
    position: relative;
  }
  ul li:hover {
    color: #651984;
  }
  ul > .type::before {
    content: "";
    display: block;
    width: 60%;
    height: 4px;
    background: #0a529b;
    position: absolute;
    top: 58px;
    left: 20%;
  }
}
.course-button {
  margin-top: 40px;
  margin-bottom: 10px;
}
.titles {
      cursor: pointer;
      width: 75%;
      float: left;
      font-size: 17px;
      line-height: 40px;
      // color: #333;
      color: var(--primary-color);
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      letter-spacing:1px;
    }
    .times {
      width: 20%;
      float: right;
      font-size: 14px;
      line-height: 40px;
    }
</style>
